import { render, staticRenderFns } from "./TrainingFeedback.vue?vue&type=template&id=6b35fbc2&scoped=true&"
import script from "./TrainingFeedback.vue?vue&type=script&lang=js&"
export * from "./TrainingFeedback.vue?vue&type=script&lang=js&"
import style0 from "./TrainingFeedback.vue?vue&type=style&index=0&id=6b35fbc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b35fbc2",
  null
  
)

export default component.exports